import React, { useState } from 'react'
import NumberFormat from 'react-number-format'
import { toast } from 'react-toastify'

import {
    IconButton,
    ListItemText,
    MenuItem,
    Menu,
    Theme,
} from '@material-ui/core'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import Grid from '@mui/material/Grid'

import { ezScheduleDetails, TemplateVendor } from '../../../models'
import { currencyFormatterNoDecimals } from '../../../helpers/CurrencyFormatter'
import { IconValue, MoneyInputValue, MoneyValue, TextValue } from '../styles'
import {
    UpdateTemplateVendorParams,
    DeleteTemplateVendorParams,
} from '../../../hooks/useEzSchedule/types'

interface Props {
    templateVendor: TemplateVendor
    key: string
    forecastedVendorTotal: number
    invoicedVendorTotal: number
    portfolio?: boolean
    updateTemplateVendor: (params: UpdateTemplateVendorParams) => void
    deleteTemplateVendor: (params: DeleteTemplateVendorParams) => void
    theme: Theme
}

export const VendorTableRow = (props: Props) => {
    const {
        templateVendor,
        key,
        forecastedVendorTotal,
        invoicedVendorTotal,
        portfolio,
        updateTemplateVendor,
        deleteTemplateVendor,
        theme,
    } = props

    const [budget, setBudget] = useState(templateVendor.budget)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <React.Fragment key={key}>
            <Grid item xs={0.5}>
                <IconValue>
                    <IconButton onClick={openMenu}>
                        <DeleteForeverIcon />
                    </IconButton>
                </IconValue>
            </Grid>
            <Grid item xs={3.5}>
                <TextValue>{templateVendor.vendor.name}</TextValue>
            </Grid>
            <Grid item xs={2}>
                <MoneyInputValue>
                    <NumberFormat
                        value={budget}
                        getInputRef={(input: HTMLInputElement | null) => {
                            input &&
                                input.addEventListener(
                                    'focus',
                                    (event: FocusEvent) => {
                                        const target = event.target as HTMLInputElement
                                        target.select()
                                    },
                                )
                        }}
                        onBlur={() => {
                            updateTemplateVendor({
                                templateVendorId: templateVendor.id,
                                budget: budget,
                            })
                        }}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const value = Number(
                                e.target.value.replace(/[^0-9.-]+/g, ''),
                            )
                            if (isNaN(value)) {
                                return
                            }
                            setBudget(value)
                        }}
                        thousandSeparator={true}
                        decimalScale={0}
                        prefix={`$`}
                        style={{
                            textAlign: 'right',
                            border: `1px solid ${props.theme.palette.grey[400]}`,
                            borderRadius: props.theme.shape.borderRadius,
                            padding: props.theme.spacing(0.25, 1),
                            width: 80,
                        }}
                    />
                </MoneyInputValue>
            </Grid>
            <Grid item xs={2}>
                <MoneyValue>
                    {currencyFormatterNoDecimals.format(forecastedVendorTotal)}
                </MoneyValue>
            </Grid>
            <Grid item xs={2}>
                <MoneyValue>
                    {currencyFormatterNoDecimals.format(
                        templateVendor.budget - forecastedVendorTotal,
                    )}
                </MoneyValue>
            </Grid>
            <Grid item xs={2}>
                <MoneyValue>
                    {currencyFormatterNoDecimals.format(invoicedVendorTotal)}
                </MoneyValue>
            </Grid>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                    onClick={() => {
                        deleteTemplateVendor({
                            templateVendorId: templateVendor.id,
                        })
                        handleClose()
                    }}
                >
                    <ListItemText>
                        Remove {templateVendor.vendor.name}
                    </ListItemText>
                </MenuItem>
            </Menu>
        </React.Fragment>
    )
}
